module.exports = __webpack_public_path__ + "0b41df77e951a30bbfccfd0a3714a1a3.svg";